import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import { VideoBoxDefinition } from '@wix/thunderbolt-components';
import { VideoBoxProps } from '../VideoBox.types';

const getFillLayersPreviewProps = (
  carmiData: VideoBoxProps,
  { isPlayingAllowed }: { isPlayingAllowed: boolean },
) => {
  const { fillLayers } = carmiData;
  if (fillLayers.video) {
    const { videoInfo } = fillLayers.video;
    videoInfo.autoPlay = videoInfo.autoPlay && isPlayingAllowed;
    fillLayers.video.videoInfo = { ...videoInfo };
    return {
      ...carmiData,
      fillLayers: { ...fillLayers },
      previewWrapperProps: {
        autoPlayVideo: videoInfo.autoPlay,
        isPlayingAllowed,
      },
    };
  }
  return carmiData;
};

const props = withCompPreviewProps<
  VideoBoxProps,
  VideoBoxDefinition,
  VideoBoxProps
>()(['isPlayingAllowed'], ({ isPlayingAllowed }, carmiData: VideoBoxProps) => {
  return getFillLayersPreviewProps(carmiData, {
    isPlayingAllowed,
  });
});

export default createComponentPreviewMapperModel({ props });
